<template>
  <div class="guest-settings-wrapper">
    <v-card class="guest-toggle-card" outlined>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-switch
              v-model="settings.lice_bez_ugovora"
              inset
              :label="
                $t('ordering_persons_without_contract') +
                ' (' +
                $t('consumption_options') +
                ')'
              "
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-expand-transition>
      <div v-show="settings.lice_bez_ugovora">
        <v-row dense>
          <v-col cols="12" md="6">
            <div class="guest-section-stack">
              <v-card class="guest-section-card" outlined>
                <v-card-title class="guest-section-title">
                  {{ $t("consumption_options") }}
                </v-card-title>
                <v-divider class="mt-2"></v-divider>
                <v-card-text>
                  <guest-consumption-section :settings="settings" />
                </v-card-text>
              </v-card>
              <v-card class="guest-section-card" outlined>
                <v-card-title class="guest-section-title">
                  {{ $t("comments") }}
                </v-card-title>
                <v-divider class="mt-2"></v-divider>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-switch
                        v-model="settings.comments_guest"
                        inset
                        :label="$t('comments_guest')"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-switch
                        v-model="settings.comments_restaurant"
                        inset
                        hide-details
                        :label="$t('comments_restaurant')"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="guest-section-stack">
              <v-card class="guest-section-card" outlined>
                <v-card-title class="guest-section-title">
                  {{ $t("delivery_time_set") }}
                </v-card-title>
                <v-divider class="mt-2"></v-divider>
                <v-card-text class="pb-0">
                  <guest-delivery-time-section
                    :settings="settings"
                    :delivery-from="deliveryFrom"
                    :delivery-to="deliveryTo"
                  />
                </v-card-text>
              </v-card>

              <v-card class="guest-section-card" outlined>
                <v-card-title class="guest-section-title">
                  {{ $t("receiving_orders") }}
                </v-card-title>
                <v-divider class="mt-2"></v-divider>
                <v-card-text>
                  <guest-order-switches-section :settings="settings" />
                </v-card-text>
              </v-card>

              <v-card class="guest-section-card" outlined>
                <v-card-title class="guest-section-title">
                  {{ $t("max_days_to_order_daily_menu") }}
                </v-card-title>
                <v-divider class="mt-2"></v-divider>
                <v-card-text>
                  <guest-order-limits-section
                    :settings="settings"
                    :broj-dana-bez-menija="brojDanaBezMenija"
                  />
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>

        <v-card class="guest-section-card mt-2" outlined>
          <v-card-title class="guest-section-title">
            <v-row no-gutters align="start">
              <v-switch v-model="settings.guest_day.new_time_changes" inset />
              {{ $t("new_time_changes") }}
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <guest-daily-time-changes-section
              :settings="settings"
              :week-days="weekDays"
              :delivery-from="deliveryFrom"
              :delivery-to="deliveryTo"
              :delivery-from-hour="deliveryFromHour"
              :delivery-to-min="deliveryToMin"
            />
          </v-card-text>
        </v-card>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { deliveryHours, deliveryMinutes } from "@/models/timeSettings";
import GuestConsumptionSection from "@/components/restaurants/settings/guest/GuestConsumptionSection";
import GuestDeliveryTimeSection from "@/components/restaurants/settings/guest/GuestDeliveryTimeSection";
import GuestOrderLimitsSection from "@/components/restaurants/settings/guest/GuestOrderLimitsSection";
import GuestDailyTimeChangesSection from "@/components/restaurants/settings/guest/GuestDailyTimeChangesSection";
import GuestOrderSwitchesSection from "@/components/restaurants/settings/guest/GuestOrderSwitchesSection";

export default {
  name: "GuestSettingsSection",
  components: {
    GuestConsumptionSection,
    GuestDeliveryTimeSection,
    GuestOrderLimitsSection,
    GuestDailyTimeChangesSection,
    GuestOrderSwitchesSection,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deliveryFrom: deliveryHours,
      deliveryTo: deliveryMinutes,
      deliveryFromHour: deliveryHours,
      deliveryToMin: deliveryMinutes,
      brojDanaBezMenija: [
        { text: "0", val: 0 },
        { text: "1", val: 1 },
        { text: "2", val: 2 },
        { text: "3", val: 3 },
        { text: "4", val: 4 },
        { text: "5", val: 5 },
        { text: "6", val: 6 },
        { text: "7", val: 7 },
        { text: "8", val: 8 },
        { text: "9", val: 9 },
        { text: "10", val: 10 },
        { text: "11", val: 11 },
        { text: "12", val: 12 },
        { text: "13", val: 13 },
        { text: "14", val: 14 },
        { text: "15", val: 15 },
      ],
    };
  },
  computed: {
    weekDays() {
      return [
        { key: "monday", label: this.$t("monday") },
        { key: "tuesday", label: this.$t("tuesday") },
        { key: "wednesday", label: this.$t("wednesday") },
        { key: "thursday", label: this.$t("thursday") },
        { key: "friday", label: this.$t("friday") },
        { key: "saturday", label: this.$t("saturday") },
        { key: "sunday", label: this.$t("sunday") },
      ];
    },
  },
};
</script>

<style scoped>
.guest-settings-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.guest-toggle-card {
  border-radius: 12px;
}

.guest-section-card {
  border-radius: 10px;
}

.guest-section-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.guest-section-title {
  font-size: 0.95rem;
  font-weight: 600;
  padding-bottom: 0;
}
</style>
